// Kazakh translations
export const kk: Record<string, string> = {
  'menu.dashboard': 'Басқару тақтасы',
  'menu.customers': 'Клиенттер',
  'menu.products': 'Өнімдер',
  'menu.users': 'Пайдаланушылар',
  'menu.settings': 'Параметрлер',
  'menu.logout': 'Шығу',
  'dashboard.title': 'Басқару тақтасы',
  'dashboard.newOrder': 'Жаңа тапсырыс',
  'order.title': 'Жаңа тапсырыс',
  'order.customer': 'Клиент',
  'order.products': 'Өнімдер',
  'order.total': 'Барлығы',
  'users.title': 'Пайдаланушылар',
  'users.name': 'Аты',
  'users.email': 'Электрондық пошта',
  'common.yes': 'Иә',
  'common.no': 'Жоқ',
  'common.cancel': 'Болдырмау',
  'common.save': 'Сақтау',
  'common.search': 'Іздеу',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Кіру',
  'login.welcome': 'Қош келдіңіз, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Электрондық пошта',
  'signup.phone': 'Телефон',
  'menu.reportsAndAccounting': 'Есептер және бухгалтерия',
  'menu.systemAndCommunication': 'Жүйе және байланыс',
};